// Tell the server when something failed on screen, so it shows up in Datadog as
// {"msg":"client_error"} next to the request logs (server: requestLog.js). Oct 16
// 2026: a trial member's yearly button did nothing and there was no record of it.
// Fire-and-forget, never throws, and a page can send at most 10 reports.
let sent = 0;
export function reportClientError(kind: string, message: string, context?: Record<string, unknown>): void {
  try {
    if (sent >= 10) return;
    sent++;
    fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ kind, message: String(message || '').slice(0, 400), page: window.location.pathname, context }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* reporting must never break the page */ }
}

// Uncaught errors and rejected promises, minus the noise every site gets from
// browser extensions and ResizeObserver.
const NOISE = /ResizeObserver loop|chrome-extension:|moz-extension:|Script error\.?$|Load failed|NetworkError|Failed to fetch/i;
export function installGlobalErrorReporting(): void {
  try {
    window.addEventListener('error', (e) => {
      const msg = e?.message || String(e?.error || '');
      if (!msg || NOISE.test(msg) || NOISE.test(e?.filename || '')) return;
      reportClientError('uncaught_error', msg, { source: e?.filename, line: e?.lineno });
    });
    window.addEventListener('unhandledrejection', (e) => {
      const msg = String((e?.reason && (e.reason.message || e.reason)) || '');
      if (!msg || NOISE.test(msg)) return;
      reportClientError('unhandled_rejection', msg);
    });
  } catch { /* ignore */ }
}
